/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon20Light = forwardRef('BuildingHomeIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.914 3.73a2.95 2.95 0 0 1 4.172 0l6.31 6.311a.5.5 0 0 0 .708-.707l-6.31-6.31a3.95 3.95 0 0 0-5.587 0l-6.31 6.31a.5.5 0 0 0 .707.707l6.31-6.31Z" }),
        React.createElement("path", { d: "M5 10.5a.5.5 0 0 0-1 0V15a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-4.5a.5.5 0 0 0-1 0V15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-4.5Z" })));
});
